import baseApi from "./baseApi";
import apiPaths from "./apiPaths";

export class playersApi extends baseApi {
    constructor(baseUrl: string, userId: string) {
        super(baseUrl, userId);
    }

    public async GetPlayersWithScoreSummaries(seriesId: string, seasonId: string, includeCareerHistory: boolean, includePastPlayers: boolean, limitCareerHistory: boolean, teamIds: string[]) {
        return await this.Post(apiPaths.GetPlayersWithScoreSummaries(seriesId, seasonId, includeCareerHistory, includePastPlayers, limitCareerHistory), teamIds);
    }
}